// Desfazer (0.67, texto 05 C1/C2): ao excluir ou arquivar qualquer coisa, aparece embaixo por 5 segundos
// "🗑️ Item excluído · Desfazer" (ou "3 itens excluídos") e "📦 Item arquivado · Desfazer".
// Exclusões e arquivamentos feitos juntos (modo seleção) viram um aviso só.
import { useSyncExternalStore } from 'react';

export type AvisoDesfazer = { id: number; tipo: 'excluir' | 'arquivar'; n: number; desfazer: () => void };
let atual: AvisoDesfazer | null = null;
let seq = 0;
let timer: ReturnType<typeof setTimeout> | null = null;
let juntar: { tipo: 'excluir' | 'arquivar'; ate: number; fns: (() => void)[] } | null = null;
const ouvintes = new Set<() => void>();
const avisar = () => ouvintes.forEach(f => f());

/** Registra uma ação que pode ser desfeita. Chamadas seguidas (menos de 0,6 s) do mesmo tipo somam no mesmo aviso. */
export function oferecerDesfazer(tipo: 'excluir' | 'arquivar', desfazer: () => void) {
  const agora = Date.now();
  if (!juntar || juntar.tipo !== tipo || agora > juntar.ate) juntar = { tipo, ate: agora + 600, fns: [] };
  juntar.ate = agora + 600;
  juntar.fns.push(desfazer);
  const fns = juntar.fns;
  atual = { id: ++seq, tipo, n: fns.length, desfazer: () => { [...fns].reverse().forEach(f => { try { f(); } catch { /* segue */ } }); } };
  if (timer) clearTimeout(timer);
  timer = setTimeout(fechar, 5000);
  avisar();
}
export function fechar() { atual = null; juntar = null; if (timer) { clearTimeout(timer); timer = null; } avisar(); }
export function usarDesfazer() {
  return useSyncExternalStore(cb => { ouvintes.add(cb); return () => { ouvintes.delete(cb); }; }, () => atual);
}
